module.exports = __webpack_public_path__ + "img/emptystate-forms.77e4b127.svg";